import React from 'react';
import { DataCollectionGapSummary } from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';
import AcceptAndReviewButton from './AcceptAndReviewButton';
import RequestMoreFilesButton from './RequestMoreFilesButton';
import RequestMoreFilesPanel from './RequestMoreFilesPanel';
import StartOverWithNewFilesButton from './StartOverWithNewFilesButton';

interface GapResolutionSectionProps {
    requestId: string;
    operationId: string;
    summaryPayload: DataCollectionGapSummary;
    showGapReport: boolean;
    onRequestMoreFiles: () => void;
    onBackToGapSummary: () => void;
    onEmailSent: (recipientEmail: string) => Promise<void>;
    onStartOver?: () => void;
    setErrorMessage: (message: string | null) => void;
}

export const GapResolutionSection: React.FC<GapResolutionSectionProps> = ({
    requestId,
    operationId,
    summaryPayload,
    showGapReport,
    onRequestMoreFiles,
    onBackToGapSummary,
    onEmailSent,
    onStartOver,
    setErrorMessage
}) => {
    const localize = useLocalizer();

    if (showGapReport) {
        return (
            <RequestMoreFilesPanel
                requestId={requestId}
                operationId={operationId}
                summaryPayload={summaryPayload}
                onEmailSent={onEmailSent}
                onBack={onBackToGapSummary}
                onStartOver={onStartOver}
                setPageErrorMessage={setErrorMessage}
            />
        );
    }

    return (
        <section className="gap-summary-section">
            <div className="gap-summary-section-header">
                <h4>{localize('Choose your next step')}</h4>
            </div>
            <div className="gap-summary-resolution-list">
                <RequestMoreFilesButton onClick={onRequestMoreFiles} />
                <AcceptAndReviewButton
                    requestId={requestId}
                    setErrorMessage={setErrorMessage}
                />
                <StartOverWithNewFilesButton
                    onStartOver={onStartOver}
                    setErrorMessage={setErrorMessage}
                />
            </div>
        </section>
    );
};

export default GapResolutionSection;
